var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpecificationParameterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.599609 1.4001C0.599609 0.95827 0.957782 0.600098 1.39961 0.600098H2.99961C3.44144 0.600098 3.79961 0.95827 3.79961 1.4001V3.0001C3.79961 3.44193 3.44144 3.8001 2.99961 3.8001H1.39961C0.957782 3.8001 0.599609 3.44193 0.599609 3.0001V1.4001ZM2.99961 1.4001H1.39961V3.0001H2.99961V1.4001ZM13.3996 2.6001H5.39961V1.8001H13.3996V2.6001ZM0.599609 6.2001C0.599609 5.75827 0.957782 5.4001 1.39961 5.4001H2.99961C3.44144 5.4001 3.79961 5.75827 3.79961 6.2001V7.8001C3.79961 8.24193 3.44144 8.6001 2.99961 8.6001H1.39961C0.957782 8.6001 0.599609 8.24192 0.599609 7.8001V6.2001ZM2.99961 6.2001H1.39961V7.8001H2.99961V6.2001ZM13.3996 7.4001H5.39961V6.6001H13.3996V7.4001ZM0.599609 11.0001C0.599609 10.5583 0.957782 10.2001 1.39961 10.2001H2.99961C3.44144 10.2001 3.79961 10.5583 3.79961 11.0001V12.6001C3.79961 13.0419 3.44144 13.4001 2.99961 13.4001H1.39961C0.957782 13.4001 0.599609 13.0419 0.599609 12.6001V11.0001ZM2.99961 11.0001H1.39961V12.6001H2.99961V11.0001ZM13.3996 12.2001H5.39961V11.4001H13.3996V12.2001Z",
    fill: "#CFCFCF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpecificationParameterIcon);
export default __webpack_public_path__ + "static/media/specification-parameter-icon.15c855bd860a5031285982c31e5d7763.svg";
export { ForwardRef as ReactComponent };